import type { FC } from 'react';
import type { ChannelInfoForList } from '@shared/api';
import {
  Avito,
  ChannelWidget,
  CreatorMax,
  TelegramTypeLarge,
  VkTypeLarge,
} from '@shared/assets/icons/components';

interface ChannelTypeIconProps {
  type: ChannelInfoForList['type'];
  size?: number;
}

export const ChannelTypeIcon: FC<ChannelTypeIconProps> = ({ type, size = 24 }) => {
  if (type === 'widget') {
    return <ChannelWidget width={size} height={size} />;
  }

  if (type === 'vk_bot') {
    return <VkTypeLarge width={size} height={size} />;
  }

  if (type === 'max_bot') {
    return <CreatorMax width={size} height={size} />;
  }

  if (type === 'avito') {
    return <Avito width={size} height={size} />;
  }

  return <TelegramTypeLarge width={size} height={size} />;
};
